import React, { FC } from 'react';
import Wrapper from '../../components/wrapper/Wrapper';
import styles from './Documentation.module.scss';
import Layout from '../../layout/Layout';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import { ITheme } from '@/src/assets/interfaces/themeInterface';
import PortableTextSection from '../../sections/portableTextSection/PortableTextSection';

type TDocData = {
  docData: Partial<ITheme>;
};

const Documentation: FC<TDocData> = ({ docData }) => {
  return (
    <Layout>
      <Breadcrumbs />
      <Wrapper className={styles.wrapper}>
        {docData && docData.content && <PortableTextSection content={docData.content} />}
      </Wrapper>
    </Layout>
  );
};

export default Documentation;
